import { GlobalStyle, Theme } from 'hui';
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';
import { ASSET_HUI_IMAGES_URL_BASE } from '../../constants/Domains';
import { INFO as EMAILS_INFO } from '../../constants/Emails';
import { onLoginCheckSuccess } from '../actions/user';
import ScrollToTopOnNavigate from '../components/ScrollToTopOnNavigate';

const OpusGlobalStyle = createGlobalStyle`
  * { 
    min-height: 0;
    min-width: 0;
  }

  a { 
    color: inherit; text-decoration: none; 
  } 

  .ReactModal__Body--open {
    overflow: hidden;
  }
`;

const PageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  min-width: 320px;
`;

const App: React.FC<{}> = ({ children }) => {
  return (
    <ThemeProvider theme={Theme}>
      <PageContainer>
        <GlobalStyle />
        <OpusGlobalStyle />
        <Helmet
          defaultTitle="hipages - Change the way you tradie"
          titleTemplate="%s - hipages.com.au"
        >
          <script
            crossOrigin="anonymous"
            src="https://polyfill.io/v3/polyfill.min.js??flags=gated&features=default%2Ces2015%2Ces2016%2Ces2017%2Ces2018%2CSymbol.asyncIterator%2CIntersectionObserver%2CIntersectionObserverEntry"
          ></script>
          <meta charSet={'uft8'} />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta property="fb:app_id" content="102132386588242" />
          <meta property="og:type" content="article" />
          <meta property="og:site_name" content="Home Improvement Pages" />
          <meta name="classification" content="Home Improvement" />
          <meta name="author" content="Home Improvement Pages Australia" />
          <meta name="Reply-to" content={EMAILS_INFO} />
          <meta name="copyright" content="2004 Home Improvement Pages Australia" />
          <meta
            name="description"
            content="We provide a better, smarter way to connect you with trusted tradies to get a job done well. Join over 2 million Australians who’ve changed the way they tradie."
          />
          <link rel="dns-prefetch" href="https://assets.homeimprovementpages.com.au" />
          <link rel="dns-prefetch" href="https://mediacache.homeimprovementpages.com.au" />
          <link rel="dns-prefetch" href="https://thumbnail-cloud.homeimprovementpages.com.au" />
          <link
            rel="alternate"
            type="application/rss+xml"
            title="RSS 2.0"
            href="//feeds.feedburner.com/hipages"
          />
          <link
            rel="apple-touch-icon-precomposed"
            sizes="180x180"
            href={`${ASSET_HUI_IMAGES_URL_BASE}hipages-180.png`}
          />
          <link
            rel="apple-touch-icon-precomposed"
            sizes="152x152"
            href={`${ASSET_HUI_IMAGES_URL_BASE}hipages-152.png`}
          />
          <link
            rel="apple-touch-icon-precomposed"
            sizes="144x144"
            href={`${ASSET_HUI_IMAGES_URL_BASE}hipages-144.png`}
          />
          <link
            rel="apple-touch-icon-precomposed"
            sizes="120x120"
            href={`${ASSET_HUI_IMAGES_URL_BASE}hipages-120.png`}
          />
          <link
            rel="apple-touch-icon-precomposed"
            sizes="114x114"
            href={`${ASSET_HUI_IMAGES_URL_BASE}hipages-114.png`}
          />
          <link
            rel="apple-touch-icon-precomposed"
            sizes="76x76"
            href={`${ASSET_HUI_IMAGES_URL_BASE}hipages-76.png`}
          />
          <link
            rel="apple-touch-icon-precomposed"
            sizes="72x72"
            href={`${ASSET_HUI_IMAGES_URL_BASE}hipages-72.png`}
          />
          <link
            rel="apple-touch-icon-precomposed"
            href={`${ASSET_HUI_IMAGES_URL_BASE}hipages-57.png`}
          />
          <link rel="icon" sizes="192x192" href={`${ASSET_HUI_IMAGES_URL_BASE}hipages-192.png`} />
          <link rel="icon" sizes="128x128" href={`${ASSET_HUI_IMAGES_URL_BASE}hipages-128.png`} />
          <meta
            name="msapplication-TileImage"
            content={`${ASSET_HUI_IMAGES_URL_BASE}hipages-144.png`}
          />
          <meta name="msapplication-TileColor" content="#faa25c" />
          <script>{`window.pageContexts = window.pageContexts || [];`}</script>
        </Helmet>
        <ScrollToTopOnNavigate />
        {children}
      </PageContainer>
    </ThemeProvider>
  );
};

export default connect(null, { onLoginCheckSuccess })(App);
